import { Component } from '@angular/core';

@Component({
  selector: 'app-customer-review-leadform',
  templateUrl: './customer-review-leadform.component.html',
  styleUrls: ['./customer-review-leadform.component.css']
})
export class CustomerReviewLeadformComponent {

}
